<div class="spinner-grow text-dark my-3" role="status">
    <span class="visually-hidden">جاري التحميل...</span>
</div>